import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    batchClassTypeListLoading: false,
    batchClassTypeListSuccess: null,
    batchClassTypeListError: '',

    getBatchClassTypeLoading: false,
    getBatchClassTypeSuccess: null,
    getBatchClassTypeError: '',

    createBatchClassTypeLoading: false,
    createBatchClassTypeSuccess: {},
    createBatchClassTypeError: '',
}

export const batchClassTypeSlice = createSlice({
    name: 'batchClassType',
    initialState, 
    reducers: {
        setBatchClassTypeListLoading: (state) => {
            state.batchClassTypeListLoading = true;
            state.batchClassTypeListSuccess = null;
            state.batchClassTypeListError = '';
        },
        setBatchClassTypeListSuccess: (state, action) => {
            state.batchClassTypeListLoading = false;
            state.batchClassTypeListSuccess = action.payload;
            state.batchClassTypeListError = '';
        },
        setBatchClassTypeListError: (state, action) => {
            state.batchClassTypeListLoading = false;
            state.batchClassTypeListSuccess = null;
            state.batchClassTypeListError = action.payload;
        },
        setGetBatchClassTypeLoading: (state) => {
            state.getBatchClassTypeLoading = true;
            state.getBatchClassTypeSuccess = {};
            state.getBatchClassTypeError = '';
        },
        setGetBatchClassTypeSuccess: (state, action) => {
            state.getBatchClassTypeLoading = false;
            state.getBatchClassTypeSuccess = action.payload;
            state.getBatchClassTypeError = '';
        },
        setGetBatchClassTypeError: (state, action) => {
            state.getBatchClassTypeLoading = false;
            state.getBatchClassTypeSuccess = {};
            state.getBatchClassTypeError = action.payload;
        },
        setCreateBatchClassTypeLoading: (state) => {
            state.createBatchClassTypeLoading = true;
            state.createBatchClassTypeSuccess = {};
            state.createBatchClassTypeError = '';
        },
        setCreateBatchClassTypeSuccess: (state, action) => {
            state.createBatchClassTypeLoading = false;
            state.createBatchClassTypeSuccess = action.payload;
            state.createBatchClassTypeError = '';
        },
        setCreateBatchClassTypeError: (state, action) => {
            state.createBatchClassTypeLoading = false;
            state.createBatchClassTypeSuccess = {};
            state.createBatchClassTypeError = action.payload;
        },
        resetDetails: (state) => {
            state.getBatchClassTypeSuccess = {};
            state.createBatchClassTypeSuccess = {};
        },
    }
})

export const { setBatchClassTypeListLoading, setBatchClassTypeListSuccess, setBatchClassTypeListError,
    setGetBatchClassTypeLoading, setGetBatchClassTypeSuccess, setGetBatchClassTypeError, 
    setCreateBatchClassTypeLoading, setCreateBatchClassTypeSuccess, setCreateBatchClassTypeError,
    resetDetails
} = batchClassTypeSlice.actions;


export default batchClassTypeSlice.reducer;